class HeavyDutySlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.heavy-duty-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.heavy-duty-slider__dot'));
    this.prevButton = this.querySelector('.heavy-duty-slider__arrow--prev');
    this.nextButton = this.querySelector('.heavy-duty-slider__arrow--next');
    this.index = 0;
    this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length < 2) return;

    this.slides[this.index].style.transform = 'translateX(0%)';

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.go(this.index - 1, 'prev'));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.go(this.index + 1, 'next'));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.addEventListener('mouseenter', this.pause.bind(this));
    this.addEventListener('mouseleave', this.play.bind(this));
    this.addEventListener('focusin', this.pause.bind(this));
    this.addEventListener('focusout', this.play.bind(this));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pause();
      } else {
        this.play();
      }
    });

    this.play();
  }

  disconnectedCallback() {
    this.pause();
  }

  directionTo(next) {
    const total = this.slides.length;
    const forwardSteps = (next - this.index + total) % total;
    const backwardSteps = (this.index - next + total) % total;
    return forwardSteps <= backwardSteps ? 'next' : 'prev';
  }

  go(nextIndex, direction) {
    const total = this.slides.length;
    const next = (nextIndex + total) % total;
    if (next === this.index) return;
    if (!direction) direction = this.directionTo(next);

    const current = this.slides[this.index];
    const upcoming = this.slides[next];
    const enterFrom = direction === 'prev' ? '-100%' : '100%';
    const exitTo = direction === 'prev' ? '100%' : '-100%';

    upcoming.classList.add('is-resetting');
    upcoming.style.transform = `translateX(${enterFrom})`;
    void upcoming.offsetWidth;
    upcoming.classList.remove('is-resetting');
    upcoming.classList.add('is-active');
    upcoming.style.transform = 'translateX(0%)';
    upcoming.setAttribute('aria-hidden', 'false');

    current.classList.remove('is-active');
    current.classList.add('is-exiting');
    current.style.transform = `translateX(${exitTo})`;
    current.setAttribute('aria-hidden', 'true');

    this.dots.forEach((dot, i) => {
      const isActive = i === next;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    clearTimeout(this.resetTimer);
    this.resetTimer = setTimeout(() => {
      current.classList.add('is-resetting');
      current.classList.remove('is-exiting');
      current.style.transform = '';
      void current.offsetWidth;
      current.classList.remove('is-resetting');
    }, 750);

    this.index = next;
    this.restartAutoplay();
  }

  play() {
    if (this.reducedMotion || this.slides.length < 2) return;
    clearInterval(this.timer);
    this.timer = setInterval(() => this.go(this.index + 1, 'next'), this.speed);
  }

  pause() {
    clearInterval(this.timer);
  }

  restartAutoplay() {
    if (this.timer) this.play();
  }
}

if (!customElements.get('heavy-duty-slider')) {
  customElements.define('heavy-duty-slider', HeavyDutySlider);
}
